// @flow
import React from 'react'
import classnames from 'classnames'

type PropsT = {
  className?: string,
  children?: any,
  centered?: boolean,
  stacked?: boolean,
  right?: boolean,
  heading?: string
}

const ButtonGroup = ({ className, children, centered, stacked, right, heading }: PropsT) => (
  <section className={classnames('ButtonGroup clearfix', className, {
    'ButtonGroup--centered': centered,
    'ButtonGroup--stacked': stacked,
    'ButtonGroup--right': right
  })}>
    {heading &&
      <h3 className='ButtonGroup__heading'>{heading}</h3>
    }
    {children}
  </section>
)

export default ButtonGroup
